<div [formGroup]="checkboxForm" class="checkbox-group-container">
  <label class="group-label">{{ config.label }}</label>
  <div class="options-container">
    <mat-checkbox 
      *ngFor="let option of config.options" 
      [formControlName]="option.value"
      class="checkbox-option">
      {{ option.label }}
    </mat-checkbox>
  </div>
  <!-- Mensagem de erro (opcional, adaptar conforme seu sistema de erros) -->
  <mat-error *ngIf="group.get(config.name)?.invalid && group.get(config.name)?.touched">
     Este campo é obrigatório ou inválido.
  </mat-error>
</div> 